import styled from 'styled-components/macro';

import { lowHeightScreens, smallScreens, mediumScreens } from '../../common/fontElements';
import * as colors from 'components/common/colorConstants';

export const Container = styled.div`
  overflow-y: auto;
  height: 100%;
  font-size: 13px;
  background-color: ${colors.baseBackground};
  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 11px;
  }
`;

export const HeaderSection = styled.div`
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0px;
  text-align: left;
  font-family: Lato;
  font-weight: 500;
  padding: 30px 30px 20px;
  text-align: center;
  color: ${colors.black1};
  background-color: ${colors.baseBackground};
`;

export const ResultSection = styled.div`
  padding: 10px 40px;
`;

export const AlertSection = styled.div`
  padding-bottom: 20px;
`;

export const MacroResult = styled.div`
  color: ${colors.black1};
  cursor: pointer;
  text-align: left;
  padding: 20px;
  line-height: 1.42857;
  vertical-align: top;
  font-weight: 300;
  width: 100%;
  transition: 0.3s;
  background-color: ${colors.baseBackground};
  border: 1px solid ${colors.darkGray13};
  box-shadow: 1px 3px 4px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  margin: 15px 0px;
  animation: fadeIn;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  opacity: 0%;
  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
  &:hover {
    color: ${colors.black2};
  }
`;

MacroResult.displayName = 'Result';

export const MacroResultHeader = styled.span`
  font-family: 'Lato-Bold', sans-serif;
  font-weight: 700;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const TypeIcon = styled.img`
  margin-right: 10px;
`;

export const CheckIcon = styled.img`
  margin: 10px auto 20px;
  display: block;
`;

export const Thanks = styled.p`
  padding: 0px;
  font-family: 'Lato-Bold';
  margin: 0px 0px 20px;
  color: ${colors.black1};
`;

export const TypeMarker = styled.span`
  margin-right: 5px;
  font-size: 10px;
`;

export const EscalationMarkerSpan = styled(TypeMarker)`
  margin-right: 5px;
  color: #b83130;
`;

export const NewMarker = styled(TypeMarker)`
  margin-right: 5px;
  color: ${colors.darkGreen1};
`;

export const MacroResultTitle = styled.p`
  font-weight: bold;
  margin: 0px;
  padding: 0px;
  font-size: 13px;
  line-height: 1;
  color: ${colors.purple1};
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 12px;
  }
  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 10px;
  }
`;

export const MacroResultContent = styled.div`
  font-size: 12px;
  margin-top: 10px;
  font-weight: normal;
  color: ${colors.lightBlack};
  word-wrap: break-word;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
  }
  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }

  > p {
    margin-bottom: 0;
  }
`;
